module.exports = __webpack_public_path__ + "static/media/covidimg.d7265326.PNG";